import PropTypes from 'prop-types'

import { Box } from '@mui/material'

import LoginAnimation from '../../../assets/animations/login'
import Logo from '../../../assets/images/ctt-logo.svg'

import styles from './backgroundlStyles'

const AuthBackground = ({ children }) => {
  return (
    <Box sx={styles.backgroundContainer}>
      <Box sx={styles.logoContainer}>
        <img src={Logo} alt="" />
      </Box>
      <Box sx={styles.loginAnimationContainer}>
        <LoginAnimation width={700} height={560} />
      </Box>
      {children}
    </Box>
  )
}

AuthBackground.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AuthBackground
